import React, { Component } from 'react';
import { Form, Input, Tabs, message, Select, DatePicker, Button, Radio,Modal,Cascader,Checkbox,Col } from 'antd';
import axios from 'axios';
import API from '../../../../../API/api';
import moment from 'moment';
import TreeControl from './TreeControl'
import { ASSIST, KNOWLEDGEWITHISSUE,ALBUM,SUBJECT } from '../../../../../utils/questionManageType';

const { RangePicker } = DatePicker;
const FormItem = Form.Item;
const TabPane = Tabs.TabPane;
const Option = Select.Option;

class CreateTask extends Component{
    state = {
        loading: false,
        tab:'1',
        start_time:'',
        end_time:'',
        section:false,
        assistList:[],
        knowledgeTreeList:[],
        knowledgeTreeListFetching:false,
        assistTreeList:[],
        assistTreeListFetching:false,

        skipExplain:false,
        skipTask:true,
        typeShowList:false,
        skipTypeShow:['25'],
    }
    getCateitemList = ()=>{
        let URL = API.CATEITEM_LIST
        axios.post(URL,{}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({typeShowList:res.data.type_show})
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });

    }
    onTabChange = (key) => {
        this.setState({tab:key})
    }

    handleAssistChange = (value) => {
        let rootId = value[value.length - 1];
        this.setState({assist:rootId,section:false})
        this.handleGetTreeList(rootId,ASSIST,'assistTreeList')
    }
    handleSkip = (val, type) => {
        this.setState({[type]:val.target.checked})
    }
    handleTreeSelect=(selectedKeys,type)=>{
        this.setState({section:selectedKeys[0]||false})
    }
    handleGetTreeList = (rootId, relate_type,list) => {
        this.setState({knowledgeTreeListFetching:true});
        axios.post(API.GET_TREE_LIST,{ type: relate_type, rootId }).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({[list]:res.data.list,knowledgeTreeListFetching:false});
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }
    handleGetTreeListAlbum = () => {
        if(this.props.user.subject!==SUBJECT.ENGLISH){return}

        this.setState({albumTreeListFetching:true});
        axios.post(API.SELECT_ALBUM_LIST).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({albumList:res.data,albumTreeListFetching:false});
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }
    onOk = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {


                let data = {};
                data.name = values.name;
                data.source_id = this.state.section;
                if(this.state.tab == 1){
                    if(!this.state.section)
                    {
                        data.source_type=11;
                        data.source_id=this.state.assist;
                    }
                    else{
                        data.source_type=1;
                    }
                }else if(this.state.tab == 26){
                    data.source_type=26;
                }else if(this.state.tab == 3){
                    data.source_type=3;
                }
                if(!data.source_id){return message.error('请选择教辅或知识点')}
                data.question_start_time = this.state.start_time;
                data.question_end_time = this.state.end_time;

                data.skip_explain = ~~this.state.skipExplain;
                data.skip_task = ~~this.state.skipTask;

                data.mark = values.mark||'';
                if(this.props.taskId){
                    data.task_id = this.props.taskId
                }
                data.skip_type_show = this.state.skipTypeShow
                axios.post(API.EXPLAIN_TASK_ADD,data).then((res)=>{
                    res = res.data
                    if (res.code === 0) {
                        message.success('任务创建成功');
                        this.setState({ loading: false, visible:false});
                        this.props.refresh();
                        this.props.onCancel();
                    }else{
                        message.error(res.message);
                        this.setState({ loading: false});
                    }
                },(error)=>{
                    message.error('网络错误！');
                });
            }


        });
    }
    componentDidMount(){
        this.getCateitemList()
        axios.post(API.GET_NO_SUBJECT_ASSIST_LIST).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({assistList:res.data.list});
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
        this.handleGetTreeList(0,KNOWLEDGEWITHISSUE,'knowledgeTreeList')
        this.handleGetTreeListAlbum()
    }

    disabledStartDate = (startValue) => {
        const endValue = moment(this.state.end_time);
        if (!startValue || !endValue) {
            return false;
        }
        return startValue.valueOf() > endValue.valueOf();
    }

    disabledEndDate = (endValue) => {
        const startValue = moment(this.state.start_time);
        if (!endValue || !startValue) {
            return false;
        }
        return endValue.valueOf() <= startValue.valueOf();
    }
    render(){
        const {visible } = this.props;
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 14 },
            },
        };
        const loop = data => data.map(item => {
            let option = { value: item.assist_id || item.book_id || item.edition_id, label: item.name }
            if (item.list) option.children = loop(item.list)
            return option;
        })
        return(
                <Modal
                    visible={visible}
                    title={this.props.taskId?"修改任务":"新建任务"}
                    onOk={this.onOk}
                    onCancel={this.props.onCancel}
                    footer={[
                        <Button key="back" size="large" onClick={this.props.onCancel}>取消</Button>,
                        <Button key="submit" type="primary" size="large" loading={this.state.loading} onClick={this.onOk}>
                            {this.props.taskId?"修改任务":"创建任务"}
                        </Button>,
                    ]}
                >
                    <Form>
                        <FormItem
                            {...formItemLayout}
                            label="任务名称"
                            hasFeedback
                            style={{marginBottom:10,marginRight:10,}}
                        >
                            {getFieldDecorator('name', {
                                initialValue:this.state.name,
                                rules: [{
                                    type: 'string', message: '请输入正确的任务名称',
                                }, {
                                    required: true, message: '请输入任务名称',
                                }],
                            })(
                                <Input />
                            )}
                        </FormItem>



                        <FormItem style={{marginBottom:10,marginRight:10,}} hasFeedback{...formItemLayout}
                                  label="题目上线时间">
                            {
                                getFieldDecorator('dateStart', {
                                    value:this.state.start_time !==''?moment(this.state.start_time, 'YYYY-MM-DD'):undefined,

                                })(<DatePicker
                                        format="YYYY-MM-DD"
                                        placeholder={'开始时间'}
                                        style={{marginRight:10,width:120}}
                                        disabledDate={this.disabledStartDate}
                                        onChange={(e,value)=>{this.setState({start_time:value})}}
                                    />
                                )

                            }
                            {
                                getFieldDecorator('dateEnd', {
                                    value:this.state.end_time !==''?moment(this.state.end_time, 'YYYY-MM-DD'):undefined,

                                })(<DatePicker
                                        format="YYYY-MM-DD"
                                        placeholder={'结束时间'}
                                        style={{width:120}}

                                        disabledDate={this.disabledEndDate}
                                        onChange={(e,value)=>{this.setState({end_time:value})}}
                                    />
                                )
                            }
                        </FormItem>
                        <FormItem style={{marginBottom:10,marginRight:10,}} hasFeedback{...formItemLayout}
                                  label="">
                            <Checkbox style={{marginLeft:20}} checked = { this.state.skipExplain } onChange = { (val)=>{this.handleSkip(val,'skipExplain')} }>跳过已有解析的题目</Checkbox>

                        </FormItem>
                        <FormItem style={{marginBottom:10,marginRight:10,}} hasFeedback{...formItemLayout}
                                  label="">
                            <Checkbox  style={{marginLeft:20}} checked = { this.state.skipTask } onChange = { (val)=>{this.handleSkip(val,'skipTask')}  }>跳过已有解析任务的题目</Checkbox>

                        </FormItem>
                        {
                            this.props.subject=='0'&&
                            <FormItem style={{marginBottom:10,marginRight:10,}} hasFeedback{...formItemLayout}
                                      label="">
                                {
                                    !this.state.skipMoreType&&
                                    <div>
                                        <Checkbox.Group options={[{label:'判断题',value:'25'}]}  onChange={(arrs)=>{this.setState({skipTypeShow:arrs})}} value={this.state.skipTypeShow}/>

                                        {
                                            this.state.typeShowList&&
                                            <Button onClick={()=>{this.setState({skipMoreType:true})}} style={{marginLeft:'20px'}} size={'small'}>跳过更多题型</Button>
                                        }
                                    </div>
                                }
                                {
                                    this.state.skipMoreType&&
                                    this.state.typeShowList&&
                                    <div>
                                        {

                                            <Checkbox.Group onChange={(arrs)=>{this.setState({skipTypeShow:arrs})}} value={this.state.skipTypeShow}>
                                                {
                                                    this.state.typeShowList.map((d,k)=>
                                                        <Col span={8} key={k}><Checkbox value={''+d.id}>{d.type_show}</Checkbox></Col>
                                                    )
                                                }
                                            </Checkbox.Group>
                                        }
                                    </div>
                                }

                            </FormItem>
                        }

                        <Tabs defaultActiveKey= { `1` } onChange={ this.onTabChange }>
                            <TabPane tab="章节" key = { `1` }>
                                <Cascader allowClear={ false } popupPlacement="topLeft" style={ {width:"60%"} } options={ loop(this.state.assistList) ? loop(this.state.assistList) : [] } onChange={ this.handleAssistChange } placeholder="Please select" />
                                <TreeControl
                                    treeData={ this.state.assistTreeList }
                                    key = { ASSIST }
                                    loading= { this.state.assistTreeListFetching }
                                    handleTreeSelect = { selectedKeys => this.handleTreeSelect(selectedKeys, ASSIST) }
                                    checkable= { false }
                                    checkStrictly = { false }
                                />
                            </TabPane>
                            <TabPane tab="知识点及考点" key={ `${KNOWLEDGEWITHISSUE}` }>
                                <TreeControl
                                    treeData={ this.state.knowledgeTreeList }
                                    key = { KNOWLEDGEWITHISSUE }
                                    loading= { this.state.knowledgeTreeListFetching }
                                    handleTreeSelect = { selectedKeys => this.handleTreeSelect(selectedKeys, KNOWLEDGEWITHISSUE) }
                                    checkable= { false }
                                    checkStrictly = { false }
                                />
                            </TabPane>
                            {
                                this.props.user.subject===SUBJECT.ENGLISH&&
                                <TabPane tab="专辑" key={ `${ALBUM}` }>
                                    <TreeControl
                                        treeData={ this.state.albumList }
                                        key = { ALBUM }
                                        loading= { this.state.albumTreeListFetching }
                                        handleTreeSelect = { selectedKeys => this.handleTreeSelect(selectedKeys, ALBUM) }
                                        checkable= { false }
                                        checkStrictly = { false }
                                    />
                                </TabPane>
                            }

                        </Tabs>
                    </Form>
                </Modal>
        );
    }

}
const WrappedCreateTaskForm = Form.create()(CreateTask);
export default WrappedCreateTaskForm


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_explain/explain_task_list/creat_task/view.js